export default function exportHTML({
  savedCustomFontList = [],
  canvasDimension,
  finalDOMObj,
  animationFinalObjToString,
  layerLink,
  completeObj,
  typeDiff,
  expandClose,
  animationObjecStringified,
  backupFallback,
  bannerName,
}) {
  const fixFontFamilyCss = (css = "") =>
    css.replace(/font-family\s*:\s*([^;]+);/gi, (_, rawVal) => {
      const raw = String(rawVal).trim();
      if (!raw) return "font-family: Arial, sans-serif;";

      const parts = raw
        .split(",")
        .map((p) => p.trim())
        .filter(Boolean);
      let first = (parts[0] || "").replace(/^["']|["']$/g, "");
      const rest = parts.slice(1);

      if (/\s/.test(first)) first = `"${first}"`;
      if (rest.length === 0) rest.push("sans-serif");

      return `font-family:${[first, ...rest].join(", ")};`;
    });

  const backupFileName = (url) => {
    const extension = new URL(url).pathname.split(".").pop();

    return `backup.${extension}`;
  }

  const clickHandlers = finalDOMObj.clickHandlers || [];
  const toClickHandlerKey = (id) =>
    String(id || "").replace(/[^a-zA-Z0-9_]/g, "_");

  const globalLinkEnabled =
    canvasDimension?.checkGloballink === true &&
    canvasDimension?.globalLink &&
    canvasDimension.globalLink !== "https://" &&
    canvasDimension.globalLink !== "http://" &&
    canvasDimension.globalLink !== "";

  const urlToTag = {};
  let tagIdx = 1;
  const clickTagLines = [];
  clickHandlers.forEach(({ url }) => {
    if (!urlToTag[url]) {
      urlToTag[url] = `clickTag${tagIdx++}`;
      clickTagLines.push(`  var ${urlToTag[url]} = "${url}";`);
    }
  });

  if (globalLinkEnabled) {
    const gUrl = canvasDimension.globalLink;
    if (!urlToTag[gUrl]) {
      urlToTag[gUrl] = `clickTag${tagIdx++}`;
      clickTagLines.push(`  var ${urlToTag[gUrl]} = "${gUrl}";`);
    }
  }

  const handlerFnLines = clickHandlers
    .map(({ id, url }) => {
      const tag = urlToTag[url];
      const handlerKey = toClickHandlerKey(id);
      return `  function exitHandler_${handlerKey}(e) { e.stopPropagation(); if (loaded && typeof Enabler !== "undefined") { Enabler.exit(${tag}); } window.open(${tag}); }`;
    })
    .join("\n");

  // Prefer component links (e.g. text inside scrollbar) over the canvas global
  // link. Also ignore bare scrollbar/ISI interactions so scrolling/reading does
  // not trigger the global clickthrough.
  const linkedLayerUrlMapLines = clickHandlers
    .map(({ id, url }) => `    ${JSON.stringify(String(id))}: ${urlToTag[url]},`)
    .join("\n");

  const globalLinkHandlerFn = globalLinkEnabled
    ? `  var linkedLayerUrlById = {
${linkedLayerUrlMapLines}
  };
  function exitHandler_canvas_page(e) {
    var canvasEl = document.getElementById("canvas-page");
    var node = e.target;
    while (node && node !== canvasEl) {
      if (node.id && linkedLayerUrlById[node.id]) {
        e.stopPropagation();
        var _compTag = linkedLayerUrlById[node.id];
        if (loaded && typeof Enabler !== "undefined") { Enabler.exit(_compTag); }
        window.open(_compTag);
        return;
      }
      if (node.classList && (
        node.classList.contains("custom-scrollbar") ||
        node.classList.contains("viewport") ||
        node.classList.contains("overview") ||
        node.classList.contains("scrollbar") ||
        node.classList.contains("track") ||
        node.classList.contains("thumb")
      )) {
        return;
      }
      if (node.id && String(node.id).indexOf("ISIInfo") !== -1) {
        return;
      }
      node = node.parentElement;
    }
    e.stopPropagation();
    var _tag = ${urlToTag[canvasDimension.globalLink]};
    if (loaded && typeof Enabler !== "undefined") { Enabler.exit(_tag); }
    window.open(_tag);
  }`
    : "";

  const bindingLines = clickHandlers
    .map(({ id }) => {
      const handlerKey = toClickHandlerKey(id);
      return `    var _el_${handlerKey} = document.getElementById("${id}"); if (_el_${handlerKey}) { _el_${handlerKey}.style.cursor = "pointer"; _el_${handlerKey}.addEventListener("click", exitHandler_${handlerKey}, false); }`;
    })
    .join("\n");

  const globalLinkBindingLine = globalLinkEnabled
    ? `    var _el_canvas_page = document.getElementById("canvas-page"); if (_el_canvas_page) { _el_canvas_page.style.cursor = "pointer"; _el_canvas_page.addEventListener("click", exitHandler_canvas_page, false); }`
    : "";


  const fontFaceCss = savedCustomFontList
  .filter((font) => !font.isDuplicateFont)
  .map(
    (font) => `
@font-face {
  font-family: '${font.familyName}';
  src: url('${font.dataUrl}') format('${font.format}');
}`
  )
  .join("\n");

  const escapeHtml = (value = "") =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

  const htmlTitle = escapeHtml(
    `${bannerName || "banner"}`
  );
  
  return `
<html>

<head>
    <meta charset="utf-8">
    <title>${htmlTitle}</title>
    ${layerLink}
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
    <meta name="format-detection" content="telephone=no" />
    <meta http-equiv="X-UA-Compatible" content="IE=Edge" />
    <meta name="ad.size" content="width=${canvasDimension?.width}, height=${canvasDimension?.height}" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0">

    <link href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;700&display=swap" rel="stylesheet">
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.4.0/css/font-awesome.min.css">

    <script>
        var loaded = false;
    </script>
    <script src="https://s0.2mdn.net/ads/studio/Enabler.js" onload="loaded=true;"></script>
    <script type="text/javascript" src="https://code.jquery.com/jquery-3.7.1.min.js"></script>
    <script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.20.3/TweenMax.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/tinyscrollbar/2.4.2/jquery.tinyscrollbar.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/3.2.4/gsap.min.js"></script>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/gsap/1.10.2/plugins/CSSPlugin.min.js"></script>

    <style>
        * {
            -moz-box-sizing: border-box;
            -webkit-box-sizing: border-box;
            box-sizing: border-box;
        }

        body {
            padding: 0;
            margin: 0;
        }

        ${fixFontFamilyCss(finalDOMObj.CssCollect)}

        .customScrollBar {
            padding-bottom: 50px;
        }

        .customScrollBar::-webkit-scrollbar {
            background-color: #fff;
        }

        p {
            margin: 0px;
        }

        #Text0overview p {
            margin: 0 1px 0px !important;
        }

        .customScrollBar::-webkit-scrollbar {
            width: 6px;
            height: 6px;
        }

        .customScrollBar::-webkit-scrollbar-thumb {
            border-radius: 5px;
            box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
            -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
            background: rgba(0, 0, 0, 0.2);
        }

        .custonScrollBar::-webkit-scrollbar {
            background-color: #fff;
        }

        #imc-backup-fallback {
            display: none;
            position: absolute;
            top: 0;
            left: 0;
            width: ${canvasDimension?.width || 0}px;
            height: ${canvasDimension?.height || 0}px;
            z-index: 2147483647;
        }

        #imc-backup-fallback img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: fill;
        }

        .disable .thumb {
            display: none;
        }

        #canvas-page [id^="Button"] {
            margin: 0;
            text-decoration: none !important;
            box-sizing: border-box;
        }

        #canvas-page [id^="Button"] > .btn-text {
            width: 100%;
            max-width: 100%;
            box-sizing: border-box;
        }

        #canvas-page [id^="Button"] p {
            margin: 0 !important;
            padding: 0 !important;
        }

        #canvas-page [id^="Button"] ul,
        #canvas-page [id^="Button"] ol {
            display: block;
            width: 100%;
            max-width: 100%;
            margin: 0 !important;
            padding-left: 15px !important;
            box-sizing: border-box;
            list-style-position: outside;
        }
        #canvas-page [id^="Button"] li {
            display: list-item;
        }

        ${fontFaceCss}
    </style>
</head>

<body class="customScrollBar">
    ${
    backupFallback?.s3Url
    ? `<noscript><img src="${backupFileName(backupFallback.s3Url)}" alt="Backup image fallback"></noscript>`
    : ""
    }
    ${typeDiff}

    <script>
        var backupFallbackEnabled = ${backupFallback?.s3Url ? "true" : "false"};
        var backupFallbackBootTimeoutMs = 12000;
        var backupFallbackRenderGraceMs = 3000;
        var backupFallbackShown = false;
        var bannerBootstrapped = false;
        var runtimeInitAttempted = false;
        var runtimeInitSucceeded = false;
        var animationStartTriggered = false;
        var backupFallbackTimer = null;

        function clearBackupFallbackTimer() {
            if (backupFallbackTimer) {
                clearTimeout(backupFallbackTimer);
                backupFallbackTimer = null;
            }
        }

        function markBannerBootstrapped() {
            bannerBootstrapped = true;
            runtimeInitSucceeded = true;
            animationStartTriggered = true;
            clearBackupFallbackTimer();
            var canvasNode = document.getElementById("canvas-page");
            if (canvasNode) canvasNode.style.display = "block";
            if (!backupFallbackEnabled) return;
            var backupFallbackNode = document.getElementById("imc-backup-fallback");
            if (backupFallbackNode) backupFallbackNode.style.display = "none";
            backupFallbackShown = false;
        }

        function showBackupFallback() {
            if (!backupFallbackEnabled || backupFallbackShown || bannerBootstrapped) return;

            backupFallbackShown = true;
            clearBackupFallbackTimer();

            var canvasNode = document.getElementById("canvas-page");
            if (canvasNode) canvasNode.style.display = "none";

            var backupFallbackNode = document.getElementById("imc-backup-fallback");
            if (backupFallbackNode) backupFallbackNode.style.display = "block";
        }

        function scheduleBackupFallbackTimer(delayMs) {
            if (!backupFallbackEnabled) return;
            clearBackupFallbackTimer();
            backupFallbackTimer = setTimeout(function () {
                if (!runtimeInitAttempted || !runtimeInitSucceeded || !animationStartTriggered) {
                    showBackupFallback();
                }
            }, delayMs);
        }

        function markAnimationStart() {
            animationStartTriggered = true;
            markBannerBootstrapped();
        }

        if (backupFallbackEnabled) {
            scheduleBackupFallbackTimer(backupFallbackBootTimeoutMs);
        }

        var arrObject = ${animationFinalObjToString}
        var fps = ${canvasDimension.fps}
        var tempGpsa = [];
        var count = 0;
        var clearTimer = [];
        var MaxDuration = [];
        var collectID = [];
        var loopAnimation = ${canvasDimension.loopAnimation||0}
        var set = true;
        let maxIndex = -1;
        let completeObj = ${completeObj};
        let animationObjecStringified = ${animationObjecStringified};
        ${clickTagLines.join("\n")}
        ${handlerFnLines}
        ${globalLinkHandlerFn}
        function getElements(elem) {
            let element = [];
            for (let i = 0; i < elem.length; i++) {
                element.push(document.getElementById(elem[i]));

            }
            return element;
        }

        var linkedLayerIds = [${clickHandlers
          .map(({ id }) => JSON.stringify(String(id)))
          .join(", ")}];

        function getElementOpacity(el) {
            if (!el) return 1;
            // Prefer computed style (what hit-testing uses). gsap.getProperty can
            // briefly disagree during overlapping zero-duration opacity tweens
            // and falsely mark linked hit areas as non-clickable.
            var cssOpacity = parseFloat(window.getComputedStyle(el).opacity);
            if (isFinite(cssOpacity)) return cssOpacity;

            var gsapOpacity = parseFloat(
                typeof gsap !== "undefined" && gsap.getProperty
                    ? gsap.getProperty(el, "opacity")
                    : NaN
            );
            return isFinite(gsapOpacity) ? gsapOpacity : 1;
        }

        function isEffectivelyVisible(opacity) {
            return isFinite(opacity) && opacity > 0.01;
        }

        function getBaseZIndex(el) {
            if (!el) return "0";
            var stored = el.getAttribute("data-base-z-index");
            if (stored != null && stored !== "") return stored;
            var computedZ = window.getComputedStyle(el).zIndex;
            if (!computedZ || computedZ === "auto") computedZ = "0";
            el.setAttribute("data-base-z-index", computedZ);
            return computedZ;
        }

        function applyOpacityInteractionState(el, opacity) {
            if (!el) return;
            // Never rewrite hit-area overlay stacking here — host z-index owns that.
            if (el.classList && el.classList.contains("imc-hit-area-overlay")) {
                return;
            }
            var baseZ = getBaseZIndex(el);
            if (!isEffectivelyVisible(opacity)) {
                el.style.zIndex = "0";
                el.style.pointerEvents = "none";
            } else {
                el.style.zIndex = baseZ;
                el.style.pointerEvents = "";
            }
        }

        function getActiveTimelineTime() {
            if (tempGpsa && tempGpsa.length) {
                var tl = tempGpsa[tempGpsa.length - 1];
                if (tl && typeof tl.time === "function") {
                    var t = Number(tl.time());
                    if (isFinite(t)) return t;
                }
            }
            return 0;
        }

        function isOverlayInActiveRange(overlay, timelineTime) {
            var start = parseFloat(overlay.getAttribute("data-timeline-start"));
            var end = parseFloat(overlay.getAttribute("data-timeline-end"));
            if (!isFinite(start)) start = 0;
            if (!isFinite(end)) end = Number.POSITIVE_INFINITY;
            // Inclusive end so last-frame hits still register.
            return timelineTime + 0.001 >= start && timelineTime - 0.001 <= end;
        }

        function syncImageHitAreaSizeScale() {
            var hosts = document.querySelectorAll(".imc-hit-area-overlays");
            for (var i = 0; i < hosts.length; i++) {
                var host = hosts[i];
                var imageEl = host.parentElement;
                if (!imageEl) continue;

                var baseWidth = parseFloat(host.getAttribute("data-base-width"));
                var baseHeight = parseFloat(host.getAttribute("data-base-height"));
                if (!(baseWidth > 0) || !(baseHeight > 0)) continue;

                var currentWidth = imageEl.offsetWidth;
                var currentHeight = imageEl.offsetHeight;
                if (
                    typeof gsap !== "undefined" &&
                    gsap.getProperty
                ) {
                    var tweenedWidth = parseFloat(gsap.getProperty(imageEl, "width"));
                    var tweenedHeight = parseFloat(gsap.getProperty(imageEl, "height"));
                    if (isFinite(tweenedWidth) && tweenedWidth > 0) {
                        currentWidth = tweenedWidth;
                    }
                    if (isFinite(tweenedHeight) && tweenedHeight > 0) {
                        currentHeight = tweenedHeight;
                    }
                }
                if (!(currentWidth > 0)) currentWidth = baseWidth;
                if (!(currentHeight > 0)) currentHeight = baseHeight;

                var scaleX = currentWidth / baseWidth;
                var scaleY = currentHeight / baseHeight;
                if (!isFinite(scaleX) || !isFinite(scaleY)) continue;

                // Keep host in design-space px so overlays (and their GSAP tweens)
                // stay correct; scale maps them onto the live image box.
                host.style.width = baseWidth + "px";
                host.style.height = baseHeight + "px";
                host.style.transformOrigin = "0 0";
                host.style.transform =
                    "scale(" + scaleX + "," + scaleY + ")";
            }
        }

        function syncOpacityClickability() {
            syncImageHitAreaSizeScale();

            var handledIds = {};
            var timelineTime = getActiveTimelineTime();
            var hosts = document.querySelectorAll(".imc-hit-area-overlays");
            for (var i = 0; i < hosts.length; i++) {
                var imageEl = hosts[i].parentElement;
                if (!imageEl) continue;
                var parentVisible = isEffectivelyVisible(getElementOpacity(imageEl));
                var overlays = hosts[i].querySelectorAll(".imc-hit-area-overlay");
                applyOpacityInteractionState(imageEl, getElementOpacity(imageEl));
                for (var j = 0; j < overlays.length; j++) {
                    var overlay = overlays[j];
                    var hasLink = overlay.getAttribute("data-has-link") === "1";
                    var overlayVisible = isEffectivelyVisible(getElementOpacity(overlay));
                    var inRange = isOverlayInActiveRange(overlay, timelineTime);
                    // Allow clicks when parent is visible and either GSAP shows the
                    // overlay. This
                    // avoids one-frame GSAP opacity mismatches disabling links.
                    var canClick =
                        hasLink &&
                        parentVisible &&
                        (overlayVisible || inRange);
                    overlay.style.pointerEvents = canClick ? "auto" : "none";
                    if (overlay.id) handledIds[overlay.id] = true;
                }
                if (imageEl.id) handledIds[imageEl.id] = true;
            }

            // Every animated layer: opacity 0 → z-index 0 and not clickable.
            if (animationObjecStringified && typeof animationObjecStringified === "object") {
                for (var animId in animationObjecStringified) {
                    if (!Object.prototype.hasOwnProperty.call(animationObjecStringified, animId)) {
                        continue;
                    }
                    if (handledIds[animId]) continue;
                    var animEl = document.getElementById(animId);
                    if (!animEl) continue;
                    if (animEl.classList && animEl.classList.contains("imc-hit-area-overlay")) {
                        continue;
                    }
                    applyOpacityInteractionState(animEl, getElementOpacity(animEl));
                    handledIds[animId] = true;
                }
            }

            // Linked layers (may not be in animation object)
            for (var c = 0; c < linkedLayerIds.length; c++) {
                var id = linkedLayerIds[c];
                if (handledIds[id]) continue;
                var el = document.getElementById(id);
                if (!el) continue;
                if (el.classList && el.classList.contains("imc-hit-area-overlay")) {
                    continue;
                }
                applyOpacityInteractionState(el, getElementOpacity(el));
            }
        }

        // Back-compat alias used by timeline callbacks below.
        var syncImageHitAreaPointerEvents = syncOpacityClickability;

        function prepareInitialFrame(AryObj) {
            gsap.ticker.fps(fps);

            var _initSeen = {};
            for (var _ii = 0; _ii < AryObj.length; _ii++) {
                var _atomId = AryObj[_ii].atoms[0];
                if (_initSeen[_atomId]) continue;

                _initSeen[_atomId] = true;
                var _initElem = document.getElementById(_atomId);
                if (_initElem) {
                    var _initOp = AryObj[_ii].op;
                    var _setVars = {};
                    for (var _k in _initOp) {
                        if (_k !== "delay" && _k !== "ease") {
                            _setVars[_k] = _initOp[_k];
                        }
                    }
                    gsap.set(_initElem, _setVars);
                }
            }
            syncImageHitAreaPointerEvents();
        }

        function playAnimation(AryObj) {
            for (var _ti = 0; _ti < tempGpsa.length; _ti++) {
                if (tempGpsa[_ti] && typeof tempGpsa[_ti].kill === "function") {
                    tempGpsa[_ti].kill();
                }
            }

            tempGpsa = [];
            collectID = [];
            gsap.ticker.fps(fps);

            var masterTimeLine = gsap.timeline({
                onUpdate: syncImageHitAreaPointerEvents,
                onComplete: function () {
                    syncImageHitAreaPointerEvents();
                    if (loopAnimation > 0) setTimeout(loopClear, 100);
                }
            });

            for (var i = 0; i < AryObj.length; i++) {
                var obj = AryObj[i];
                var value = getElements(obj.atoms);
                if (value[0]) {
                    var tweenVars = {};
                    for (var _tk in obj.op) {
                        if (_tk !== "delay") tweenVars[_tk] = obj.op[_tk];
                    }
                    tweenVars.duration = obj.duration;
                    masterTimeLine.to(value, tweenVars, obj.op.delay || 0);
                    collectID.push("#" + obj.atoms);
                }
            }

            tempGpsa.push(masterTimeLine);
            syncImageHitAreaPointerEvents();
            set = false;
        }

        function animationRepeat(AryObj) {
            prepareInitialFrame(AryObj);
            playAnimation(AryObj);
        }


        function customScrollISIPI(id) {
            var scrollContainer = document.getElementById(id);
            if (!scrollContainer) return;

            // Pixels advanced per tick and tick cadence drive the scroll speed.
            var scrollStep = 0.15;
            var scrollInterval = 25;
            // Hold at the bottom before resetting back to the top (CSB-1449).
            var bottomPauseMs = 2000;

            var scrollAmount = 0;
            var isHovered = false;
            // While true the container is held at the bottom; ticking is paused and the
            // reset-to-top is governed by the bottom-hold countdown below.
            var isPausedAtBottom = false;
            var tickTimer = null;
            var bottomPauseTimer = null;
            // The bottom-hold countdown is hover-aware: it only advances while the user
            // is not hovering, so hovering at the bottom freezes there until unhover.
            var bottomPauseRemaining = bottomPauseMs;
            var bottomPauseStartedAt = 0;
            // Set by the wheel handler so the next scroll event is recognised as a
            // user gesture rather than our own programmatic stepping.
            var manualScrollPending = false;

            function maxScroll() {
                return scrollContainer.scrollHeight - scrollContainer.clientHeight;
            }

            function startTicking() {
                if (tickTimer) return;
                tickTimer = setInterval(tick, scrollInterval);
            }

            function stopTicking() {
                if (tickTimer) {
                    clearInterval(tickTimer);
                    tickTimer = null;
                }
            }

            function clearBottomPauseTimer() {
                if (bottomPauseTimer) {
                    clearTimeout(bottomPauseTimer);
                    bottomPauseTimer = null;
                }
            }

            function startBottomCountdown() {
                // Run the remaining hold; when it completes we reset to the top.
                clearBottomPauseTimer();
                bottomPauseStartedAt = Date.now();
                bottomPauseTimer = setTimeout(resetAndRestart, bottomPauseRemaining);
            }

            function pauseBottomCountdown() {
                // Freeze the countdown (used while hovering) and bank the time left.
                if (!isPausedAtBottom || !bottomPauseTimer) return;
                clearBottomPauseTimer();
                var elapsed = Date.now() - bottomPauseStartedAt;
                bottomPauseRemaining = Math.max(0, bottomPauseRemaining - elapsed);
            }

            function resetAndRestart() {
                // After the bottom hold fully elapses, jump straight to the top (no
                // transition) and resume stepping from position 0.
                clearBottomPauseTimer();
                isPausedAtBottom = false;
                bottomPauseRemaining = bottomPauseMs;
                scrollAmount = 0;
                scrollContainer.scrollTop = 0;
                if (!isHovered) startTicking();
            }

            function tick() {
                // Hover and the bottom-hold both freeze motion; the thumb stays put
                // so it cannot flicker or partially animate during the hold.
                if (isHovered || isPausedAtBottom) return;

                var limit = maxScroll();
                if (limit <= 0) {
                    // Content is not taller than the container: nothing to scroll.
                    stopTicking();
                    return;
                }

                if (scrollAmount < limit) {
                    scrollAmount += scrollStep;
                    if (scrollAmount > limit) scrollAmount = limit;
                    scrollContainer.scrollTop = scrollAmount;
                } else {
                    // Reached the bottom: pin to the bottom, stop stepping, and start
                    // the hold countdown (tick only runs while not hovered, so we are
                    // not hovering at this point).
                    isPausedAtBottom = true;
                    bottomPauseRemaining = bottomPauseMs;
                    scrollContainer.scrollTop = limit;
                    stopTicking();
                    startBottomCountdown();
                }
            }

            function onHover() {
                // Pause immediately on hover. At the bottom this freezes the hold
                // countdown so it stays put until the pointer leaves.
                if (isHovered) return;
                isHovered = true;
                pauseBottomCountdown();
            }

            function onUnhover() {
                if (!isHovered) return;
                isHovered = false;
                // At the bottom, resume the remaining hold countdown; otherwise resume
                // stepping from the current position (not from the top).
                if (isPausedAtBottom) {
                    startBottomCountdown();
                } else {
                    startTicking();
                }
            }

            function pointerInsideContainer(clientX, clientY) {
                var rect = scrollContainer.getBoundingClientRect();
                return (
                    clientX >= rect.left &&
                    clientX <= rect.right &&
                    clientY >= rect.top &&
                    clientY <= rect.bottom
                );
            }

            scrollContainer.addEventListener('mouseenter', onHover);
            scrollContainer.addEventListener('mouseleave', onUnhover);

            // During a native scrollbar thumb drag the pointer is captured, so if the
            // user drags outside the iframe and releases the button there, the
            // container's own 'mouseleave' never fires and auto-scroll stays paused
            // forever. These document/window-level fallbacks recover from that case.

            // Pointer physically left the iframe viewport (fires when not captured).
            document.addEventListener('mouseleave', onUnhover);

            // Focus left the iframe (e.g. the button was released over the parent page
            // after dragging the thumb out); treat it as the pointer having left.
            window.addEventListener('blur', onUnhover);

            // When any drag ends, re-check where the pointer actually is. If it is no
            // longer over the container (released outside the iframe), force unhover.
            document.addEventListener('mouseup', function (e) {
                if (!pointerInsideContainer(e.clientX, e.clientY)) {
                    onUnhover();
                }
            });

            // When the user manually scrolls (wheel or dragging the native scrollbar),
            // adopt their position so the auto-scroll continues from where they left it
            // instead of snapping back to its own tracked position.
            scrollContainer.addEventListener('wheel', function () {
                manualScrollPending = true;
            });

            scrollContainer.addEventListener('scroll', function () {
                // Our own stepping keeps scrollTop within ~1px of scrollAmount, so a
                // larger delta (thumb drag) or a flagged wheel gesture means the user
                // moved it; sync the tracker to the real position in that case only.
                if (
                    manualScrollPending ||
                    Math.abs(scrollContainer.scrollTop - scrollAmount) > 2
                ) {
                    manualScrollPending = false;
                    scrollAmount = scrollContainer.scrollTop;

                    // If the user scrolled away from the bottom while we were holding
                    // there, abandon the bottom-hold (and its reset-to-top countdown)
                    // so it resumes stepping from the new position instead of jumping
                    // to the top when the drag ends.
                    if (isPausedAtBottom && scrollAmount < maxScroll() - 2) {
                        clearBottomPauseTimer();
                        isPausedAtBottom = false;
                        bottomPauseRemaining = bottomPauseMs;
                        if (!isHovered) startTicking();
                    }
                }
            });

            startTicking();
        }

        function loopClear() {
            if (loopAnimation > 0) {
                $(collectID.join()).removeAttr("style");

                setTimeout(function () { animationRepeat(arrObject); }, 100);

                loopAnimation = loopAnimation - 1;
            }
        }

        function stopAndStart(id) {
            clearInterval(clearTimer[id]);

            setTimeout(function () {
                let tinyscrollbar = $("#" + id + "ISIInfo").data("plugin_tinyscrollbar");

                tinyscrollbar.update(0);
            }, 1000);
        }
        ${expandClose};
        function getCurrentOverviewOffset(id) {
            var overviewPos = $("#" + id + "overview").position();
            var overviewTop = overviewPos ? overviewPos.top : 0;
            if (isNaN(overviewTop)) return 0;
            return overviewTop < 0 ? Math.abs(overviewTop) : 0;
        }

        function ControlThumb(id) {
            $("#" + id + "thumb, #" + id + "track, #" + id + "viewport, #" + id + "overview, #" + id + "overview *")
                .off("click.autoScrollStop")
                .on("click.autoScrollStop", function () {
                    clearInterval(clearTimer[id]);
                });

            var maxOverviewTop = $("#" + id + "overview").height() - $("#" + id + "viewport").height();
            if (maxOverviewTop <= 0) {
                stopAndStart(id);
                $("#" + id + "scrollbar").addClass(id + "activeScroller");
                return;
            }

            $("#" + id + "scrollbar").addClass(id + "activeScroller");
            var currContentTop = Math.min(getCurrentOverviewOffset(id) + 5, maxOverviewTop);
            let tinyscrollbar = $("#" + id + "ISIInfo").data("plugin_tinyscrollbar");

            if (!tinyscrollbar) {
                clearInterval(clearTimer[id]);
                return;
            }

            if (currContentTop < maxOverviewTop) {
                tinyscrollbar.update(currContentTop);
            } else {
                tinyscrollbar.update(maxOverviewTop);
                clearInterval(clearTimer[id]);
            }
        }
        function scrollTrap(id) {
            $("#" + id + 'ISIInfo').tinyscrollbar();
            var step = 10;
            var updateScroll = function (nextValue) {
                var scroll = $("#" + id + "ISIInfo").tinyscrollbar();
                var plugin = $(scroll).data().plugin_tinyscrollbar;
                if (plugin) {
                    plugin.update(nextValue);
                }
            };

            $("#" + id + "arrowBottom").bind("click", function () {
                var maxOverviewTop = Math.max(
                    $("#" + id + "overview").height() - $("#" + id + "viewport").height(),
                    0
                );
                var currContentTop = getCurrentOverviewOffset(id);
                updateScroll(Math.min(currContentTop + step, maxOverviewTop));
            });
            var scrollInterval = null;
            $("#" + id + "arrowBottom", "#" + id + "arrowTop").bind("mousedown", function (e) {
                if ($(e.target).hasClass("bottom_arrow"))
                    scrollInterval = setInterval(function () {
                        $("#" + id + "arrowBottom").trigger("click");
                    }, 100);
                else
                    scrollInterval = setInterval(function () {
                        $("#" + id + "arrowTop").trigger("click");
                    }, 100);
            });

            $("#" + id + "arrowBottom", "#" + id + "arrowTop").bind("mouseup mousemove", function (e) {
                clearInterval(scrollInterval);
            });
            $("#" + id + "arrowTop").bind("click", function () {
                var currContentTop = getCurrentOverviewOffset(id);
                updateScroll(Math.max(currContentTop - step, 0));
            });
        }

        function startCustomScrollAfterAnimation() {
            var maxDuration = 0;

            for (var i = 0; i < arrObject.length; i++) {
                var totalDuration =
                    arrObject[i].duration + arrObject[i].op.delay;

                if (totalDuration > maxDuration) {
                    maxDuration = totalDuration;
                }
            }

            if (maxDuration === 0) {
                maxDuration = 1;
            }

            var remainingTime = maxDuration * 1000;
            var startTimeout = null;
            var startTime = 0;
            var scrollStarted = false;

            function startScroll() {
                if (scrollStarted) return;

                scrollStarted = true;

                for (var j = 0; j < completeObj.length; j++) {
                    scrollTrap(completeObj[j].id);

                    if (completeObj[j].autoScroll) {
                        (function (scrollId) {
                            var autoScroll = setInterval(function () {
                                ControlThumb(scrollId);
                            }, 90);

                            clearTimer[scrollId] = autoScroll;
                        })(completeObj[j].id);
                    } else {
                        customScrollISIPI(completeObj[j].id);
                    }
                }
            }

            function scheduleScrollStart() {
                if (scrollStarted || document.hidden || startTimeout) {
                    return;
                }

                startTime = Date.now();

                startTimeout = setTimeout(function () {
                    startTimeout = null;
                    remainingTime = 0;
                    startScroll();
                }, remainingTime);
            }

            function pauseScrollStart() {
                if (!startTimeout) {
                    return;
                }

                clearTimeout(startTimeout);
                startTimeout = null;

                remainingTime -= Date.now() - startTime;

                if (remainingTime < 0) {
                    remainingTime = 0;
                }
            }

            document.addEventListener("visibilitychange", function () {
                if (document.hidden) {
                    pauseScrollStart();
                } else {
                    if (remainingTime <= 0) {
                        startScroll();
                    } else {
                        scheduleScrollStart();
                    }
                }
            });

            scheduleScrollStart();
        }

        var bannerStarted = false;

        function startBannerOnce() {
            if (bannerStarted) return;
            bannerStarted = true;

            prepareInitialFrame(arrObject);
            markBannerBootstrapped();
            playAnimation(arrObject);
            startCustomScrollAfterAnimation();
        }

        function pageLoadedHandler() {
            startBannerOnce();
        }

        function initializeCanvasRuntime() {
            runtimeInitAttempted = true;
            try {
                ${bindingLines}
                ${globalLinkBindingLine}
                runtimeInitSucceeded = true;
                startBannerOnce();

                if (
                    loaded &&
                    typeof Enabler !== "undefined" &&
                    typeof studio !== "undefined" &&
                    Enabler.isInitialized &&
                    !Enabler.isInitialized()
                ) {
                    Enabler.addEventListener(
                        studio.events.StudioEvent.INIT,
                        function () {
                            if (!Enabler.isPageLoaded()) {
                                Enabler.addEventListener(
                                    studio.events.StudioEvent.PAGE_LOADED,
                                    pageLoadedHandler
                                );
                            }
                        }
                    );
                } else if (
                    loaded &&
                    typeof Enabler !== "undefined" &&
                    typeof studio !== "undefined" &&
                    !Enabler.isPageLoaded()
                ) {
                    Enabler.addEventListener(
                        studio.events.StudioEvent.PAGE_LOADED,
                        pageLoadedHandler
                    );
                }
            } catch (error) {
                showBackupFallback();
                throw error;
            }
        }

        function initializeTinyScrollbar() {
            for (let i = 0; i < completeObj.length; i++) {
                $("#" + completeObj[i].id + 'ISIInfo').tinyscrollbar({
                    trackSize: completeObj[i].trackHeight,
                    thumbSize: completeObj[i].thumbHeight,
                    thumbSizeMin: 2,
                    wheelSpeed: 5
                });
            }
        }

        function disableScrollRestoration() {
            if ("scrollRestoration" in history) {
                history.scrollRestoration = "manual";
            }
        }

        function initializeApp(){
            disableScrollRestoration();
            if (document.readyState === "loading") {
                document.addEventListener("DOMContentLoaded", () => {
                    initializeCanvasRuntime()
                    initializeTinyScrollbar()
                })
            }else {
                initializeCanvasRuntime()
                initializeTinyScrollbar()
            }
        }
        
        initializeApp()
    </script>
</body>

</html>`;
}
